"use client";

import { useState, useTransition } from "react";
import { DeleteConfirmationDialog } from "@/components/modals/DeleteConfirmation";

type PartnerAuthorizationWithdrawActionDictionary = {
  label: string;
  title: string;
  description: string;
  cancelLabel: string;
  pendingLabel: string;
  error: string;
};

export function PartnerAuthorizationWithdrawAction({
  dictionary,
  withdrawAction,
}: {
  dictionary: PartnerAuthorizationWithdrawActionDictionary;
  withdrawAction: () => Promise<void>;
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [withdrawError, setWithdrawError] = useState<string | null>(null);
  const [isWithdrawing, startWithdrawing] = useTransition();

  return (
    <>
      <button
        type="button"
        className="text-normal font-normal text-zinc-900 underline transition-colors hover:text-zinc-600"
        onClick={() => {
          setWithdrawError(null);
          setDialogOpen(true);
        }}
      >
        {dictionary.label}
      </button>
      <DeleteConfirmationDialog
        open={dialogOpen}
        pending={isWithdrawing}
        title={dictionary.title}
        label={dictionary.label}
        description={dictionary.description}
        cancelLabel={dictionary.cancelLabel}
        pendingLabel={dictionary.pendingLabel}
        error={withdrawError}
        onOpenChange={(open) => {
          setDialogOpen(open);
          if (!open) setWithdrawError(null);
        }}
        onConfirm={() => {
          setWithdrawError(null);
          startWithdrawing(async () => {
            try {
              await withdrawAction();
              setDialogOpen(false);
            } catch {
              setWithdrawError(dictionary.error);
            }
          });
        }}
      />
    </>
  );
}
